import {LitElement, html, css} from 'lit';

export class LoadingElement extends LitElement {
    static get styles() {
        return css`
            :host {
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                width: 100%;
            }

            .loading-state {
                display: flex;
                width: 100%;
                text-align: center;
                font-size: 1.4em;
                flex-direction: row;
                flex-wrap: nowrap;
                align-items: center;
                justify-content: center;

                animation-name: shadow-animation;
                animation-duration: 1.5s;
                animation-timing-function: cubic-bezier(.46,.03,.52,.96);
                animation-iteration-count: infinite;
                stroke-dasharray: 30 40;
                margin: auto;
            }

            .loading-state.addmargin {
                margin: auto;
                margin-top: 2em;
                margin-bottom: 2em;
            }

            @keyframes animation {
                0% {
                    stroke-dashoffset: 0;
                }
                50% {
                    stroke-dashoffset: 51;
                }
                100% {
                    stroke-dashoffset: 139;
                }
            }
            
            svg {
                max-width: 70px;
                max-height: 70px;
            }
            
            .loading-state.addmargin svg {
                margin-right: 0.5em;
            }

            #loading-spinner {
                transform-origin: center;
                animation-name: animation;
                animation-duration: 1.5s;
                animation-timing-function: cubic-bezier(.46,.03,.52,.96);
                animation-iteration-count: infinite;
                stroke-dasharray: 30 40;
                fill: transparent;
                stroke: var(--link-color,#A89368);
                stroke-width: 3px;
                stroke-linecap: round;
                filter:url(#shadow);
            }

            .fill-white {
                fill: var(--white, #fff);
            }
            .fill-black {
                fill: var(--black, #000);
            }
        `;
    }
    
    static get properties() {
        return {
            showtext: {type: Boolean,
                hasChanged(newVal, oldVal) {
                  return newVal !== oldVal;
                },
                converter: {
                    fromAttribute: (value, type) => {
                        if (value === 'true' || value === 'True' || value == '1' || value === true) {
                            return true;
                        }
                        if (value === 'false' || value === 'False' || value == '0' || value === false ) {
                            return false;
                        }
                        return false;
                    }
                }
            },
            addmargin: {type: Boolean,
                hasChanged(newVal, oldVal) {
                  return newVal !== oldVal;
                },
                converter: {
                    fromAttribute: (value, type) => {
                        if (value === 'true' || value === 'True' || value == '1' || value === true) {
                            return true;
                        }
                        if (value === 'false' || value === 'False' || value == '0' || value === false ) {
                            return false;
                        }
                        return false;
                    }
                }
            },
            loadingtext: {type: String},
            extraClasses: {type: String},
        };
    }

    

    constructor() {
        super();
        this.showtext = true;
        this.addmargin = true;
        this.loadingtext = 'Loading...';
        this.extraClasses = '';
    }

    render() {
        return html`
            <div class="loading-state${this.addmargin ? ' addmargin' : ''}">
                <svg viewBox="-5 0 75 56.99">
                    <defs>
                        <filter id="shadow">
                            <feDropShadow dx="0" dy="0" stdDeviation="1.5" flood-color="var(--link-color,#A89368)"/>
                        </filter>
                    </defs>
                    <polygon id="loading-spinner" class=${this.extraClasses} points="32.5 9.05 15.88 0.56 0.5 8.11 0.5 23.49 17.04 31.76 17.04 48.6 32.5 56.43 47.96 48.6 47.96 31.76 64.5 23.49 64.5 8.11 49.12 0.56 32.5 9.05"/>
                </svg>
                ${this.showtext ? this.loadingtext : ''}
            </div>
        `;
    }
}

window.customElements.define('loading-element', LoadingElement);